export function contractHome(data) {
    return axios({
        url: `/api/test/insurance/home/contract/confirm`,
        method: 'post',
        data: data,
    });
}
